import { create } from 'apisauce';
import store from 'containers/store';
import * as actions from 'containers/App/actions';
import { getAuthToken } from 'utils/cookies';
import { api as apApi } from './index';

const token = getAuthToken();

// write a test for this
const streamDownload = ({ orgId, download_type, params }) => {
  return new Promise((resolve, reject) => {
    const input = {
      client_offset: new Date().getTimezoneOffset(),
      download_type,
      params,
    };
    const api = create({
      baseURL: `${process.env.REACT_APP_AP_URL}`,
      headers: {
        'content-type': 'application/json, text/plain, */*',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${token}`,
      },
    });

    try {
      api
        .post(`/api/organization/${orgId}/weddings_downloads`, input)
        .then((response) => {
          if (response.status === 401) {
            if (store) {
              store.dispatch(actions.pushAuthError(response.data?.signin_url ?? '/signin' ));
              resolve(response);
            }
          }
          poll(response, api, input, orgId)
            .then((downloadResponse) => {
              resolve(downloadResponse);
            })
            .catch((error) => {
              return reject(error);
            });
        });
    } catch (error) {
      return Promise.reject(error);
    }
  });
};

const poll = (response, api, input, orgId) => {
  return new Promise((resolve, reject) => {
    if (response.data.status === 'ready') {
      resolve(response);
    } else if (response.data.status === 'error') {
      reject(new Error('Promise failed'));
    } else {
      setTimeout(() => {
        try {
          api
            .get(
              `/api/organization/${orgId}/weddings_downloads/${response.data.token}`,
              input,
            )
            .then((getResponse) => {
              resolve(
                poll(getResponse, api, input, orgId).catch((error) => {
                  return Promise.reject(error);
                }),
              );
            });
        } catch (error) {
          reject(error);
        }
      }, 3000);
    }
  });
};

const createProjectNote = (projectId) => {
  return apApi.post(
    `/api/wedding/${projectId}/notes`,
    {},
  );
};

const saveProjectNote = (projectId, noteId, note) => {
  return apApi.put(
    `/api/wedding/${projectId}/notes/${noteId}`,
    note,
  );
};

export { streamDownload, createProjectNote, saveProjectNote };
